import React from 'react';
import ReactDOM from 'react-dom';
import * as Sentry from "@sentry/react";
import {Integrations} from "@sentry/tracing";
import {
  AppProvider,
  Frame,
} from '@shopify/polaris';

import '@shopify/polaris/build/esm/styles.css';
import en from '@shopify/polaris/locales/en.json';

import CsSkeletonLoading from "./components/csSkeletonLoading";

import {Provider} from '@shopify/app-bridge-react';
import EnvUtil from './helpers/EnvUtil';
import CsAppBridge from "./CsAppBridge";
import reportWebVitals from "./reportWebVitals";

const file_version = "21100601";

if (EnvUtil.isProd() && EnvUtil.sentryDns()) {
  Sentry.init({
    dsn: EnvUtil.sentryDns(),
    integrations: [new Integrations.BrowserTracing()],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
    release: "amazon-app@" + file_version,
    environment: "production",
    ignoreErrors: [
      "Non-Error exception captured",
      "Non-Error promise rejection captured",
      "Failed to fetch",
      "n is not a function",
      "Cannot read properties of null (reading 'hasOwnProperty')"
    ],
  });
  console.log('Start Sentry in production');
} else {
  console.log('Sentry is disabled in development');
}

class Loader extends React.Component {

  state = {
    wait: true,
    AmazonApp: null,
  }

  constructor(props) {
    super(props);
    import('./AmazonApp').then(({default: AmazonApp}) => {
      this.setState({
        AmazonApp,
        wait: false
      });
    });

    let shop_url;
    if (EnvUtil.isLocal()) {
      shop_url = "https://" + process.env.REACT_APP_DEV_STORE + ".myshopify.com";
    } else {
      if (window.location.ancestorOrigins && window.location.ancestorOrigins.length) {
        shop_url = new URL(window.location.ancestorOrigins[0]).origin;
      } else {
        shop_url = new URLSearchParams(decodeURIComponent(window.location.search)).get('shop');
      }
      // Special case, shop_url is still null
      // https://ap.common-services.com/?embedded=1&hmac=f334a74ed1c5a28d8d3fd8ca8a48ad62717f6ff43ea13a72720f088a406cbc27&host=bnAtc3BhcnRvby5teXNob3BpZnkuY29tL2FkbWlu&locale=en&session=8b60a2fa496e8e804a5bb92befb6c08cb341cf9017c97d34c88b617b7c034a4f&shop=np-spartoo.myshopify.com&timestamp=1672806398
      if (!shop_url && window.location.href) {
        shop_url = new URL(window.location.href).searchParams.get('shop');
      }
    }

    if (shop_url.search("https://") !== 0) {
      shop_url = "https://" + shop_url;
    }
    shop_url = new URL(shop_url);
    let subdomain = shop_url.hostname.split('.')[0];
    this.isDev = (subdomain === process.env.REACT_APP_DEV_STORE || subdomain === 'kbugstore');
    this.domain = subdomain + ".myshopify.com";
    this.api_key = this.isDev ? process.env.REACT_APP_SHOPIFY_API_KEY_DEV : process.env.REACT_APP_SHOPIFY_API_KEY;

    let params = new URLSearchParams(window.location.search);
    let shopify_host = params.get('host');
    let cs_host = params.get('cs_host');
    if (!shopify_host) {
      shopify_host = cs_host;
    }
    if (!shopify_host) {
      shopify_host = btoa(this.domain + '/admin');
    }
    this.shopify_host = shopify_host;
  }

  componentDidMount() {
    let loader = document.getElementById('CsLoadingBar');
    if (loader) {
      loader.style.display = "none";
    }
  }

  handleLoaded = () => {
    this.setState({wait: false});
  }

  render() {
    const config = {apiKey: this.api_key, host: this.shopify_host, forceRedirect: !this.isDev};
    const {AmazonApp, wait} = this.state;

    return (<Provider config={config}>
      {wait ?
        <AppProvider i18n={en} theme={{colorScheme: "light"}}>
          <Frame>
            <CsSkeletonLoading/>
          </Frame>
        </AppProvider> : ''}
      {AmazonApp && <AmazonApp onLoaded={this.handleLoaded} showloading={!wait}/>}
    </Provider>);
  }
}

CsAppBridge.init()
.then(lang => {
  ReactDOM.render(<Loader/>, document.getElementById('root'));
}).catch(error => {
  if (CsAppBridge.isValidApp()) {
    throw new Error(error);
  }
});


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
